
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
// import { environment } from '@environments/environment';
import { appConfig } from './app.config';

// if(environment.production) {
//   window.console.log = () => {}
// }

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
